export { default } from './VendorReviews';
